{
  "bookmarkTitleLabel": "책갈피",
  "debug": "디버그",
  "devConnectionLabel": "개발자 연결",
  "exlSection": "Experience League의 결과",
  "feedback": "피드백",
  "fetchFailed": "가져오기 실패",
  "help": "도움말",
  "helpDefaultFeatured": "Adobe Experience Cloud 학습 및 지원",
  "helpLoadError": "문제가 발생했습니다. 다시 시도해 주십시오.",
  "noBookmarks": "여기서 액세스할 수 있도록 도움말 콘텐츠를 책갈피에 추가",
  "noBookmarksTitle": "책갈피 없음",
  "noResults": "결과 없음",
  "noResultsMessage": "맞춤법을 확인하거나 다른 검색어를 사용해 보십시오.",
  "resourcesCustomerCareLabel": "고객 지원 센터",
  "resourcesStatusLabel": "상태",
  "support": "지원"
}
